import React from 'react'
import WhatWeDoHero from '../Components/servicePage/WhatWeDoHero'
import ServicesSection from '../Components/servicePage/ServicesSection'
import { Helmet } from 'react-helmet-async'

function ServiceDemo() {
    return (
        <div>
            <Helmet>
                <title>
                    What We Do | Technology & Enterprise AI & ServiceNow Consulting Services | Mobikode
                </title>

                <meta
                    name="description"
                    content="Explore Mobikode's technology and Enterprise AI & ServiceNow Consulting services, including AI and automation, cloud engineering, product engineering, enterprise applications, ServiceNow, data analytics, and digital workflows."
                />

                <meta
                    name="keywords"
                    content="What We Do Mobikode, Technology Services, Enterprise AI & ServiceNow Consulting Services, IT Services Company, Technology Consulting Services, AI Automation Services, Cloud Engineering Services, Product Engineering Services, Enterprise Application Services, ServiceNow Consulting Services, Data Analytics Services, Digital Workflow Solutions, Software Development Services, IT Consulting Company"
                />

                <link
                    rel="canonical"
                    href="https://www.mobikode.com/what-we-do"
                />

                <meta
                    property="og:title"
                    content="What We Do | Technology & Enterprise AI & ServiceNow Consulting Services | Mobikode"
                />

                <meta
                    property="og:description"
                    content="Discover Mobikode's technology services designed to help businesses modernize operations, build better products, automate processes, and accelerate Enterprise AI & ServiceNow Consulting."
                />

                <meta
                    property="og:url"
                    content="https://www.mobikode.com/what-we-do"
                />

                <meta
                    property="og:type"
                    content="website"
                />

                <meta
                    property="og:image"
                    content="https://www.mobikode.com/assets/servicePage/bg1.png"
                />

                <meta
                    name="twitter:card"
                    content="summary_large_image"
                />

                <meta
                    name="twitter:title"
                    content="What We Do | Technology & Enterprise AI & ServiceNow Consulting Services | Mobikode"
                />

                <meta
                    name="twitter:description"
                    content="Learn how Mobikode helps businesses through AI, cloud, product engineering, enterprise applications, ServiceNow, analytics, and Enterprise AI & ServiceNow Consulting solutions."
                />

                <meta
                    name="twitter:image"
                    content="https://www.mobikode.com/assets/servicePage/bg1.png"
                />
            </Helmet>

            <WhatWeDoHero />
            <br/>
            <ServicesSection />


        </div>
    )
}

export default ServiceDemo
